export default class ArticleGrid extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-article-grid', ArticleGrid);
